import React from 'react';

import { AppFullScreenContainer } from 'src/components/ContainerFullScreen';
import { useTranslations } from 'src/hooks/translataions';
import { useSetDocumentTitle } from 'src/hooks';
import { locals } from 'src/constants/locals';
import { useStyles } from './styles';

export const NoMatch404: React.FC = () => {
  const styles = useStyles({});
  const { getTranslations } = useTranslations();
  useSetDocumentTitle(getTranslations(locals.appTranslations.appTitle404));

  return (
    <AppFullScreenContainer>
      <div className={styles.wrapperError}>
        <img alt="404" src="https://showfiles.net/404.jpg" />
      </div>
    </AppFullScreenContainer>
  );
};
